import React, { useCallback } from 'react';
import { LibraryContentCard } from 'src/common/components/library/content-card';
import { Node } from 'src/common/interfaces/node.interface';
import { Step } from 'src/common/interfaces/step.interface';
import { UnionStrongIcon } from 'src/monet/icons';
import { LibraryContentCardTypeEnum } from '../../common/components/library/content-card/type.enum';

type EditorContentSyncedStepCardProps = {
  node: Node;
  step: Step;
  onAddSyncedStep?: (node: Node, step: Step) => Promise<any>;
};

export const EditorContentSyncedStepCard = ({ node, step, onAddSyncedStep }: EditorContentSyncedStepCardProps) => {
  const addSyncNode = useCallback(async () => {
    if (onAddSyncedStep) {
      onAddSyncedStep(node, step);
    }
  }, [node, onAddSyncedStep, step]);

  return (
    <LibraryContentCard
      onClick={addSyncNode}
      containerClassName='space-x-sm items-center'
      renderLeftIcon={() => (
        <div className='flex items-center justify-center w-3.5 h-3.5 text-bedrock-black'>
          <UnionStrongIcon />
        </div>
      )}
      type={LibraryContentCardTypeEnum.SYNCED_STEP}
      node={node}
      draggable={false}
      name={node.name?.trim()}
    />
  );
};
